import { useQuery } from '@tanstack/react-query';
import getRequestApprovalStatus from 'Api/reschedule/getRequestApprovalStatus';
import getRequestApprovalStatusResponse from './model/response/getRequestApprovalStatusResponse';

const useGetRequestApprovalStatus = () => {
  return useQuery({
    queryKey: ['request-approval-status'],
    queryFn: async () => {
      const response = await getRequestApprovalStatus();

      return getRequestApprovalStatusResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetRequestApprovalStatus;
